module.exports = __webpack_public_path__ + "static/media/default-property-subpage-header.857d855a.jpg";